import { IS_MAC, shortcutLabel } from "#app/lib/platform";
import { openLogoutConfirmDialog } from "#app/lib/logout-confirm-dialog-context";
import { useHotkey } from "./use-hotkey";

/** Keycaps for the log-out hotkey. The Option/Shift glyphs only read right on
 *  Mac; elsewhere the keys are spelled out. Both name `altKey` + `shiftKey`. */
export const LOGOUT_SHORTCUT = IS_MAC ? ["⌥", "⇧", "Q"] : ["Alt", "Shift", "Q"];

/** The chord as one run of text, for `MenuShortcut` slots. */
export const LOGOUT_SHORTCUT_LABEL = shortcutLabel(LOGOUT_SHORTCUT);

/**
 * ⌥/Alt+⇧+Q opens the log-out confirmation — the chord the account menu's
 * Log out row advertises. It opens the confirm dialog, never signs out
 * directly: a chord a palm can land on must not end the session by itself.
 *
 * An ⌥ chord because Q's ⌘ neighborhood is OS territory on a Mac: ⌘Q quits
 * the browser and ⇧⌘Q is the system log-out — neither reaches the page.
 */
export function useLogoutHotkey(): void {
  useHotkey({ code: "KeyQ", alt: true, shift: true, handler: openLogoutConfirmDialog });
}
